export const COMPANIES_REQUEST_TARGET = '/api/companies'
